import React, { Suspense } from 'react';
import LazyLoad from 'react-lazyload';

import Bio from '../../components/anchorComponents/Bio';
import ContextualJoinOverlay from '../../components/generalComponents/ContextualJoinOverlay/ContextualJoinOverlay';
import Adds from '../../components/Adds/Adds';
import OldBio from '../../components/anchorComponents/OldBio';
import FeaturedSection from '../../components/anchorComponents/FeaturedSection';


const OldBanner = React.lazy(() => import('../../components/anchorComponents/OldBanner'));
const Banner = React.lazy(() => import('../../components/anchorComponents/Banner'));


function AnchorPageComponents(props) {
  const {
    anchor,
    anchorId,
    anchorVideoUrl,
    chatService,
    chatServiceTem,
    extractIdFromSlug,
    fetchStreamDetails,
    guestUser,
    history,
    isBanned,
    toggleContextualJoinOverlay,
    showFanZone,
    slug,
    user,
    onNetworkError,
    totalVideosCount,
    totalPublicShowsCount,
    totalGalleriesCount,
    isImageLayout,
    galleriesAndVideosCount,
    anchorPortalCampaign,
    showOverlay,
    pageItemsShown,
    setBanStatus,
    setItemsCount,
    location,
    isSpotlighing,
    spotlighedAnchorUsername,
    spotlighedAnchorNickname,
    setNakedNewsLivePromoUrl,
  } = props;

  const isPastAnchor = !anchor?.guest && !anchor?.active;

  const BioComponent = isPastAnchor ? OldBio : Bio;
  const BannerComponent = isPastAnchor ? OldBanner : Banner;

  if (!anchor) {
    return null;
  }

  return (
    <>
      <Suspense fallback={null}>
        <BannerComponent
          anchor={anchor}
          anchorId={anchorId}
          anchorVideoUrl={anchorVideoUrl}
          chatService={chatService}
          chatServiceTempted={chatServiceTem}
          extractIdFromSlug={extractIdFromSlug}
          fetchStreamDetails={fetchStreamDetails}
          guestUser={guestUser}
          history={history}
          isBanned={isBanned}
          isPastAnchor={isPastAnchor}
          isSpotlighing={isSpotlighing}
          openContextualOverlay={toggleContextualJoinOverlay}
          showFanZone={showFanZone}
          slug={slug}
          spotlighedAnchorNickname={spotlighedAnchorNickname}
          spotlighedAnchorUsername={spotlighedAnchorUsername}
          user={user}
          onNetworkError={onNetworkError}
        />
      </Suspense>
      <BioComponent
        isPastAnchor={isPastAnchor}
        anchor={anchor}
        authenticated={user.authenticated}
        extractIdFromSlug={extractIdFromSlug}
        galleriesAndVideosCount={galleriesAndVideosCount}
        history={history}
        isImageLayout={isImageLayout}
        loggedInUsername={user.user ? user.user.username : ''}
        openContextualOverlay={toggleContextualJoinOverlay}
        promoThumbnail={anchor?.fanzonePromopic}
        promoVideo={anchor?.promoClip}
        totalGalleriesCount={totalGalleriesCount}
        totalPublicShowsCount={totalPublicShowsCount}
        totalVideosCount={totalVideosCount}
        user={user}
      />
      <ContextualJoinOverlay
        anchorId={anchorId}
        anchorPortalCampaign={anchorPortalCampaign}
        anchorShortUrl={slug}
        closeContextualOverlay={toggleContextualJoinOverlay}
        history={history}
        setNakedNewsLivePromoUrl={setNakedNewsLivePromoUrl}
        showOverlay={showOverlay}
        user={user}
      />
      <FeaturedSection
        anchorName={anchor?.name}
        anchorShortUrl={slug}
        anchorUsername={anchor?.username}
        extractIdFromSlug={extractIdFromSlug}
        galleriesAndVideosCount={galleriesAndVideosCount}
        id={anchorId}
        isNakedNewsLive={false}
        location={location}
        pageItemsShown={pageItemsShown}
        setBanStatus={setBanStatus}
        setItemsCount={setItemsCount}
        showClipStore={anchor?.showClipStore}
        showFanZone={showFanZone}
        user={user}
      />
      <LazyLoad>
        <Adds isAnchorPageAd={false} />
      </LazyLoad>
    </>
  );
}

export default AnchorPageComponents;
